import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavBar from '../components/NavBar';
import './NotFound.css';

const isAdminContext = (pathname) => {
    return pathname.startsWith('/panel-admin')
        || pathname.startsWith('/crear')
        || pathname.startsWith('/editar');
};

const NotFound = () => {
    const { pathname } = useLocation();
    const admin = isAdminContext(pathname);

    const content = (
        <div className={`not-found${admin ? '' : ' not-found-public'}`}>
            <div className="not-found-content">
                <p className="not-found-code">404</p>
                <h1>Página no encontrada</h1>
                <p className="not-found-message">
                    {admin
                        ? 'La sección del panel que buscás no existe o fue movida.'
                        : 'La página que buscás no existe o ya no está disponible.'}
                </p>
                <div className="not-found-actions">
                    {admin ? (
                        <>
                            <Link to="/panel-admin" className="not-found-btn not-found-btn-primary">
                                Ir al panel
                            </Link>
                            <Link to="/" className="not-found-btn not-found-btn-secondary">
                                Ver sitio web
                            </Link>
                        </>
                    ) : (
                        <Link to="/" className="not-found-btn not-found-btn-primary">
                            Volver al inicio
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );

    if (admin) {
        return (
            <>
                <NavBar />
                {content}
            </>
        );
    }

    return content;
};

export default NotFound;
